import { supabase } from "@/integrations/supabase/client";
import { toast } from '@/hooks/use-toast';

export const usePasswordReset = (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const resetPassword = async (email: string): Promise<boolean> => {
    setIsLoading(true);
    try {
      // Use Supabase's built-in password reset flow only.
      // The custom edge-function fallback was removed because it accepted
      // an attacker-controlled resetLink, enabling phishing emails sent
      // from the SUMSAE domain.
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `https://sumsae.shop/update-password`,
      });

      if (error) {
        throw new Error(error.message || 'Failed to send reset email');
      }

      toast({
        title: 'Password Reset Email Sent',
        description: 'Check your email for password reset instructions.',
      });
      return true;
    } catch (error: any) {
      console.error('Password reset failed:', error.message);
      toast({
        title: 'Password Reset Failed',
        description: error.message || 'Please try again.',
        variant: 'destructive',
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { resetPassword };
};
